export default {
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
  apiUri: 'https://i-lead.icel.or.id/api/v1/',
  // apiUri: 'https://i-lead-api.dddtl.net/api/v1/',
  // apiUri: 'http://localhost:5203/api/v1/',
  appName: 'I-LEAD',
  mapboxAccessToken: 'pk.eyJ1IjoiYWN0aW9ubGFiIiwiYSI6ImNsMDN3NzRvdTBsMzQzbXFiM2c3Y29oOG4ifQ.5zEwWaVkWt1r38tMa8CGTA',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  encrypt(msg: string) {
    // TODO encrypt message here
    return msg;
  },
  appUri: 'https://i-lead.icel.or.id/',
};
